import React, {useEffect, useRef} from "react";
import * as Sentry from "@sentry/react";
import {useLocation} from "react-router-dom";
import styles from "./SupportWidgetButton.module.css";

/**
 * Sentry's default feedback actor button is shadow-DOM-encapsulated with a
 * hardcoded position (bottom-right, 16px margin) and no config hook to move
 * or resize it — it was sitting on top of the cookie-consent banner's own
 * buttons (see CookieConsentBanner.module.css's old padding-right hack).
 * `autoInject: false` in index.js disables that default actor; this renders
 * our own smaller, higher-positioned trigger and wires it up via the SDK's
 * documented `.attachTo()` API.
 *
 * Shown on every page except /match and /onboarding (and their /en
 * variants), whose wizards have their own bottom-right Continue/Back
 * footer buttons that this floating trigger would sit on top of.
 */
const HIDDEN_PATHS = ["/match", "/en/match", "/onboarding", "/en/onboarding"];

export default function SupportWidgetButton() {
    const buttonRef = useRef(null);
    const {pathname} = useLocation();
    const hidden = HIDDEN_PATHS.includes(pathname);

    useEffect(() => {
        if (hidden) return;
        const feedback = Sentry.getClient()?.getIntegrationByName?.("Feedback");
        if (!feedback || !buttonRef.current) return;
        feedback.attachTo(buttonRef.current);
    }, [hidden]);

    if (hidden) return null;

    return (
        <button ref={buttonRef} type="button" className={styles.button}>
            Підтримка / Support
        </button>
    );
}
